import { Node, mergeAttributes } from "@tiptap/core";

export const CustomTable = Node.create({
	name: "customTable",

	group: "block",

	content: "block+",

	tableRole: "table",

	isolating: true,

	parseHTML() {
		return [
			{
				tag: "table",
				getAttrs: element => {
					const style = element.getAttribute("style") || "";
					const border = element.getAttribute("border") || "1";
					return { style, border };
				}
			}
		];
	},

	renderHTML({ HTMLAttributes }) {
		return ["table", mergeAttributes(HTMLAttributes), 0];
	},

	addAttributes() {
		return {
			style: {
				default: "",
				parseHTML: element => element.getAttribute("style"),
				renderHTML: attributes => {
					return attributes.style ? { style: attributes.style } : {};
				}
			},
			border: {
				default: "1",
				parseHTML: element => element.getAttribute("border"),
				renderHTML: attributes => {
					return attributes.border ? { border: attributes.border } : {};
				}
			}
		};
	}
});
